import React, { FC } from 'react'
import useLocalStorage from 'react-use/lib/useLocalStorage'
import { highestZIndex } from 'shared/css/z-indexes'
import styled, { keyframes } from 'styled-components'

const slideIn = keyframes`
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(57px);
    }
`
const InnerContainer = styled.div`
    text-align: center;
    width: 1040px;
    min-width: 1040px;
    color: #fff;
    font-size: 15px;
    font-weight: normal;
    letter-spacing: 0.21px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
        text-decoration: underline;
        font-weight: bold;
        margin-left: 3.5px;
    }
`

const Banner = styled.div`
    width: 100%;
    position: absolute;
    top: -57px;
    left: 0;
    height: 57px;
    background: linear-gradient(-135deg, rgb(255, 102, 102) 0%, rgb(97, 87, 255) 100%);
    z-index: ${highestZIndex};
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: 0.3s ${slideIn} ease-out;
    animation-delay: 1.5s;
    animation-fill-mode: forwards;
`

const Content = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

const CloseButton = styled.div`
    mask-image: url('/static/img/close.svg');
    background-color: white;
    position: absolute;
    right: 10px;
    top: 15px;
    width: 30px;
    height: 30px;
    cursor: pointer;
    top: 50%;
    transform: translateY(-50%);
`

type Props = {
    children: FC
    storageLabel: string
    linkUrl?: string
    linkLabel: string
}

const PolicyBanner = ({ children, storageLabel, linkUrl, linkLabel }: Props) => {
    const [hasSeenBanner, setHasSeenBanner] = useLocalStorage(storageLabel, false)
    const hide = () => {
        setHasSeenBanner(true)
    }

    return (!hasSeenBanner && <Banner>
        <InnerContainer>
            <Content>
                {children}
                <a
                    onClick={() => {
                        hide()
                    }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={linkUrl}
                >
                    {linkLabel}
                </a>
            </Content>
        </InnerContainer>
        <CloseButton onClick={hide} />
    </Banner>)
}

export default PolicyBanner
